export default __webpack_public_path__ + "static/media/download_methodiek_posterbeurs.dd3edf56.pdf";